<template>
  <div class="main">
    <!-- 内容区 -->
    <div class="content_wrap">
      <div class="box_title">
        <ul class="result_tab">
          <li
            @click="changeTab(item)"
            v-for="item in typeList"
            :key="item.id"
            class="tab_li"
            :class="current_tab == item.id ? 'current_tab' : 'normal_tab'"
          >
            {{ item.name }}
            <div></div>
          </li>
        </ul>
      </div>
      <!--  -->
      <div class="content_box">
        <!-- 全部购买一行字 -->
        <!-- <ul class="result_tab">
          <li
            @click="changeTab(item)"
            v-for="item in typeList"
            :key="item.id"
            class="tab_li"
            :class="current_tab == item.id ? 'current_tab' : 'normal_tab'"
          >
            {{ item.name }}
            <div></div>
          </li>
        </ul> -->
        <!-- 下面展示区 -->
        <div v-if="!isloading">
          <div class="video_none" v-if="!videoList.length">
            <img :src="img.none" alt="" />
          </div>

          <ul v-show="videoList.length" class="video_wrap">
            <li
              class="video_card"
              v-for="(item, index) in videoList"
              :key="index"
            >
              <div class="card_img" @mouseenter="getVideoIndex(index)">
                <router-link
                  :to="{
                    name: 'videodetail',
                    query: {
                      post_id: item.id,
                      timeStmp: Date.parse(new Date()),
                    },
                  }"
                >
                  <img class="cover" :src="item.cover" alt="" />
                  <img class="secret" :src="img.secret" alt="">
                  <i class="status_free" v-if="item.type == 1&&item.is_pay==1">已购买</i>
              <i class="status_img" v-if="item.type==1&&item.is_pay == 0">付费下载</i>
              <i class="status_free" v-if="item.type == 0">免费下载</i>
                  <video
                  :id="'video_list'+index"
                    autoplay="autoplay"
                    muted
                    loop
                    :src="item.path"
                  ></video>
                </router-link>
              </div>
              <div class="card_message">
                <span :title="item.title" class="card_title">{{
                  item.title
                }}</span>

                <span class="card_time">{{
                  com.timeFormat(item.video_info.play_time)
                }}</span>
              </div>
            </li>
          </ul>
          <div v-show="total > 20" class="page">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              layout="pager"
              :page-size="20"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>

        <loading v-if="isloading"></loading>
      </div>
    </div>
  </div>
</template>

<script>
import loading from "./../../widget/loading";

export default {
  components: {
    loading,
  },
  data() {
    return {
      current_tab: 1,
      total: 0,
      typeList: [
        // { id: '', name: "全部" },
        { id: 1, name: "视频" },
        // { id: 1, name: "图片" },
      ],
      currentPage: 1,
      isloading: false,
      videoList: [],
    };
  },
  watch: {
    $route(to, from) {
      if (to.query && to.query.keyword) {
        // 说明修改了关键字，触发getList
        this.getList();
      }
    },
  },
  methods: {
     getVideoIndex(index){
        $('#video_list'+index)[0].currentTime=0
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    },
    changeTab(item) {
      this.current_tab = item.id;
    },
    getList() {
      this.isloading = true;
      let data = {
        cate: 1, //视频库
        all_keyword: this.com.getUrlParam("keyword"),
        page: this.currentPage,
      };
      this.$store
        .dispatch("post", { url: "videoList", data: data })
        .then((res) => {
          if (res) {
            this.isloading = false;
            if (res) {
              this.videoList = res.data.list;
              this.total = Number(res.data.count);
            }
          }
        });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style lang="less">
.current_tab {
  div {
    height: 2px;
    bottom: 18px;
  }
}
// 下拉选择框样式
.buy_time {
  .el-select {
    .el-input__inner {
      border: none;
      background-color: #f3f4f7;
      border-radius: 10px;
      width: 150px;
      font-size: 18px;
      color: #202020;
    }
  }
}

// 视频卡片样式
.video_wrap .video_card .el-card__body {
  padding: 0;
}

// 页码栏样式
.page {
  margin-top: 20px;
  text-align: center;
  .el-pagination .btn-next .el-icon,
  .el-pagination .btn-prev .el-icon {
    font-size: 18px;
  }

  .el-pager li {
    font-size: 18px;
    margin-right: 20px;
    border-radius: 5px;
    font-weight: 400;
  }

  .el-pagination button,
  .el-pagination span:not([class*="suffix"]) {
    font-size: 18px;
  }

  .el-pagination__editor.el-input .el-input__inner {
    font-size: 18px;
  }

  .el-icon-arrow-right:before {
    content: "下一页";
    font-weight: 400;
  }

  .el-pager li.active {
    background-color: #409eff;
    color: #fff;
  }
}
.video_wrap .el-card {
  border: none;
}
</style>
<style lang="less" scoped>
div.box_title {
    width: 1307px;
    height: 59px;
    line-height: 59px;
    background: #ffffff;
    padding: 0 30px;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e1e1e1;

    .title_right {
    }

    ul.result_tab {
      display: flex;
      width: 100%;

      .tab_li {
        color: #202020;
        margin-right: 52px;
        font-size: 14px;
      }
    }

    div.title_right {
      p {
        width: 90px;
        font-size: 14px;
        color: #666666;
      }
    }
  }
.video_none {
  text-align: center;
  padding: 60px;
}


.normal_tab {
  font-weight: normal;
  font-size: 16px;
}

div.content_wrap {
  width: 1300px;
  margin: 0 auto;
  padding-bottom: 30px;
  min-height: calc(100vh - 239px);

  .top_box {
    height: 80px;
    background: #ffffff;
    border-radius: 10px;
    margin-top: 25px;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    .top_title {
      display: flex;

      .top_text {
        font-size: 16px;
        color: #202020;
      }

      p:first-child {
        margin-right: 100px;
      }
    }
  }

  div.content_box {
    .buy_time {
      margin-top: 10px;
    }

    // 展示区
    .video_wrap {
      display: flex;
      flex-wrap: wrap;

      .video_card {
        height: 201px;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
        box-sizing: border-box;
        background-color: #ffffff;
        border-radius: 10px;
        position: relative;
        width: calc((100% - 75px) / 4);
        margin-top: 20px;
        margin-bottom: 5px;
        margin-right: 25px;
        overflow: hidden;
        &:hover {
          box-shadow: 0px 2px 5px 0px rgba(65, 46, 46, 0.5);
        }
        &:nth-child(4n) {
          margin-right: 0;
        }
        .card_img {
          height: 171px;
          overflow: hidden;
          &:hover {
            .cover {
              display: none;
            }
            video {
              display: block;
              height: 100%;
            }
          }
          video {
            display: none;
            width: 100%;
          }
          .cover {
            width: 100%;
            height: 100%;
          }
        }

        .card_message {
          background: #ffffff;
          padding: 0 10px;
          display: flex;
          justify-content: space-between;
          font-size: 12px;
          line-height: 30px;
          .card_time {
            padding-left: 5px;
            background: #fff;
            display: inline-block;
            z-index: 1;
          }
        }
      }
    }
  }
}
</style>